import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { InstallCodeMirror } from "codemirror-editor-vue3"; 

createApp(App)
  .use(router)
  .use(InstallCodeMirror)
  .mount('#app')
